import { AthenaExpress } from 'athena-express'
import AWS from 'aws-sdk'

import { config, logger } from '@things-factory/env'

const athenaConfig = config.get('athena', {})
const awsCredentials = {
  region: athenaConfig.region,
  accessKeyId: athenaConfig.accessKeyId,
  secretAccessKey: athenaConfig.secretAccessKey
}

if (!athenaConfig.region) {
  console.log(`\
application config for 'athena' required like following
/*
athena: {
accessKeyId: 'YOUR ACCESS KEY ID',
secretAccessKey: 'YOUR SECRET ACCESS KEY',
region: 'YOUR S3 REGION'
options: { athenaExpressConfig
  retry: 200,
  getStats: true,
  formatJson: true
}
}
*/
please, refer to https://github.com/ghdna/athena-express#advance-config-parameters for about more detail configuration parameters
`)
}

export class AthenaController {
  private athenaExpressClient
  private queryPaginationInfo = {
    NextToken: '',
    QueryExecutionId: ''
  }

  constructor() {
    if (!athenaConfig.region) {
      return
    }

    try {
      AWS.config.update(awsCredentials)
    } catch (err) {
      // missing config
      logger.error(err)
    }

    // refer to https://github.com/ghdna/athena-express#advance-config-parameters
    // about more detail configuration parameters
    let athenaExpressConfig = {
      aws: AWS,
      ...athenaConfig.options
    }

    this.athenaExpressClient = new AthenaExpress(athenaExpressConfig)
  }

  // query parameters: https://github.com/ghdna/athena-express#advance-query-parameters
  /* SAMPLE QUERY PARAMTERS
    {
      sql: "SELECT * FROM elb_logs LIMIT 3" // required,
      db: "sampledb", // optional.
      pagination: 5, //optional
      NextToken: "ARfCDXRjMk...", //optional
      QueryExecutionId: "c274843b-4c5c-4ccf-ac8b-e33d595b927d", //optional
      catalog: "hive" //optional
    };  */

  // pagination: https://github.com/ghdna/athena-express#pagination
  async query(reqQuery) {
    var queryResult
    try {
      // check if sql key is available in the input parameter
      if (reqQuery.sql === undefined || reqQuery.sql === '') return {}

      let queryInput = {
        ...reqQuery
      }

      // check if pagination would be available.
      if (
        reqQuery.pagination > 0 &&
        this.queryPaginationInfo.NextToken !== '' &&
        this.queryPaginationInfo.QueryExecutionId !== ''
      ) {
        queryInput.NextToken = this.queryPaginationInfo.NextToken
        queryInput.QueryExecutionId = this.queryPaginationInfo.QueryExecutionId
      }

      // run the query
      queryResult = await this.athenaExpressClient.query(queryInput)

      // keep pagination parameters if they are available in the result
      this.queryPaginationInfo.NextToken = queryResult?.NextToken || ''
      this.queryPaginationInfo.QueryExecutionId = queryResult?.QueryExecutionId || ''
    } catch (error) {
      logger.error(error)
    }

    return queryResult
  }
}
